import { EDisplays, setDisplay } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';

import { IndicativelyApproved } from '../IndicativelyApproved';

export const baseId = 'screen-novated-approved';

export function NovatedApproved(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleBack(): void {
        dispatch(setDisplay(EDisplays.OCR_SUMMARY));
    }

    function handleNext(): void {
        dispatch(setDisplay(EDisplays.ASSETS_AND_LIABILITIES));
    }

    return <IndicativelyApproved />;

    // return (
    //     <DisplayComponent baseId={baseId} data-testid={baseId}>
    //         <Header />
    //         <div className='flex-center pt-4 pb-10 relative'>
    //             <div className='bg-primary h-40 w-40 rounded-full' />
    //             <RemoteImage fileName='applause.svg' className='absolute' />
    //         </div>
    //         <div className='text-center _flex flex-col space-y-2'>
    //             <h3 className='uppercase text-xl text-primary font-bold '>
    //                 Great News!
    //                 <br />
    //                 You&apos;re application is Approved!
    //             </h3>
    //             <p className='text-secondary '>
    //                 Congratulations! Your profile meets all the eligibility
    //                 criteria for a novated loan.
    //             </p>
    //         </div>

    //         <div className='_flex space-x-2 mx-4 pt-4'>
    //             <Button id={`${baseId}-button-continue`} onClick={handleBack}>
    //                 Back
    //             </Button>
    //             <Button id={`${baseId}-button-continue`} onClick={handleNext}>
    //                 Next
    //             </Button>
    //         </div>
    //         <div className='flex-center w-full'>
    //             <ContactBox />
    //         </div>
    //     </DisplayComponent>
    // );
}
